// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1Kx9g","cardTitle":"Card_cardTitle___msXv","cardImg":"Card_cardImg__2MAEO","displayInFirstPosition":"Card_displayInFirstPosition__165NY"};